import type { CSSProperties } from 'react';
import type { NovelBackgroundId } from './types';

/** 静的プレースホルダー背景（AI画像生成なし）。 */
export function backgroundStyle(id: NovelBackgroundId): CSSProperties {
  const presets: Record<NovelBackgroundId, string> = {
    station_night:
      'radial-gradient(ellipse at 50% 20%, rgba(120,160,220,0.25), transparent 55%), linear-gradient(180deg, #0a1020 0%, #121a2e 40%, #1a1520 100%)',
    school_night:
      'radial-gradient(ellipse at 70% 10%, rgba(80,120,200,0.2), transparent 50%), linear-gradient(180deg, #0c1424 0%, #152030 45%, #1c1828 100%)',
    hospital_night:
      'radial-gradient(ellipse at 30% 0%, rgba(180,220,220,0.18), transparent 50%), linear-gradient(180deg, #0a1218 0%, #142028 50%, #1a2024 100%)',
    hotel:
      'radial-gradient(ellipse at 50% 0%, rgba(200,160,100,0.18), transparent 55%), linear-gradient(180deg, #141018 0%, #221c28 45%, #1a141c 100%)',
    town:
      'radial-gradient(ellipse at 20% 30%, rgba(100,140,255,0.15), transparent 45%), linear-gradient(180deg, #0c1018 0%, #182030 55%, #101418 100%)',
    isolated_house:
      'radial-gradient(ellipse at 60% 15%, rgba(160,100,80,0.2), transparent 50%), linear-gradient(180deg, #100c14 0%, #1c1418 40%, #0c0a10 100%)',
  };
  return { background: presets[id] };
}
